/* Built In Imports */
import NextLink from 'next/link';
/* External Imports */
import { Box, Flex, Image, Link, Text } from '@chakra-ui/react';
/* Internal Imports */
/* Components */
/* Styles */
import InsightSt from '@moms/styleData/InsightSt';
/* Services */

/**
 *
 * @param {Object} sectionContent
 * @param {String} region
 * @param {String} lang
 * @returns
 */
const InsightCard = ({ card, lang, height }) => {
  // console.log(card, 'card');
  const url = card.urlAlias;
  const category = card.parentUrl;
  //en/wisdom/video/bangladeshi-hindus-waqf-times-now-interviews-sadhguru
  const externalUrl = `/${lang}/wisdom/${category}/${url}`;
  const date = new Date(card.createdAt);
  let months = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ];
  const icons = {
    Article: (
      <>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
        >
          <g clip-path="url(#clip0_1121_3524)">
            <path
              d="M7.99984 5.16667C7.99984 4.0621 7.10441 3.16667 5.99984 3.16667L1.1665 3.16667L1.16651 12.8333L5.99984 12.8333C7.33317 12.8333 7.99984 13.5621 7.99984 14.6667M7.99984 5.16667C7.99984 4.0621 8.89527 3.16667 9.99984 3.16667L14.8332 3.16667L14.8332 12.8333L9.99984 12.8333C8.66651 12.8333 7.99984 13.5621 7.99984 14.6667M7.99984 5.16667L7.99984 14.6667"
              stroke="#EC1C2D"
              stroke-width="1.5"
              stroke-linecap="round"
            />
          </g>
          <defs>
            <clipPath id="clip0_1121_3524">
              <rect width="16" height="16" fill="white" />
            </clipPath>
          </defs>
        </svg>
      </>
    ),
    Video: (
      <>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
        >
          <path
            d="M6.66659 10.5L6.66659 5.49999L10.3333 7.99999L6.66659 10.5Z"
            fill="#EC1C2D"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M7.99992 2.33333C4.87031 2.33333 2.33325 4.87038 2.33325 8C2.33325 11.1296 4.87031 13.6667 7.99992 13.6667C11.1295 13.6667 13.6666 11.1296 13.6666 7.99999C13.6666 4.87038 11.1295 2.33333 7.99992 2.33333ZM1.33325 8C1.33325 4.3181 4.31802 1.33333 7.99992 1.33333C11.6818 1.33333 14.6666 4.31809 14.6666 7.99999C14.6666 11.6819 11.6818 14.6667 7.99992 14.6667C4.31802 14.6667 1.33325 11.6819 1.33325 8Z"
            fill="#EC1C2D"
          />
        </svg>
      </>
    ),
    Audio: (
      <>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
        >
          <path
            d="M6.66659 10.5L6.66659 5.49999L10.3333 7.99999L6.66659 10.5Z"
            fill="#EC1C2D"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M7.99992 2.33333C4.87031 2.33333 2.33325 4.87038 2.33325 8C2.33325 11.1296 4.87031 13.6667 7.99992 13.6667C11.1295 13.6667 13.6666 11.1296 13.6666 7.99999C13.6666 4.87038 11.1295 2.33333 7.99992 2.33333ZM1.33325 8C1.33325 4.3181 4.31802 1.33333 7.99992 1.33333C11.6818 1.33333 14.6666 4.31809 14.6666 7.99999C14.6666 11.6819 11.6818 14.6667 7.99992 14.6667C4.31802 14.6667 1.33325 11.6819 1.33325 8Z"
            fill="#EC1C2D"
          />
        </svg>
      </>
    ),
    'Sadhguru spot': (
      <>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
        >
          <g clip-path="url(#clip0_1121_3524)">
            <path
              d="M7.99984 5.16667C7.99984 4.0621 7.10441 3.16667 5.99984 3.16667L1.1665 3.16667L1.16651 12.8333L5.99984 12.8333C7.33317 12.8333 7.99984 13.5621 7.99984 14.6667M7.99984 5.16667C7.99984 4.0621 8.89527 3.16667 9.99984 3.16667L14.8332 3.16667L14.8332 12.8333L9.99984 12.8333C8.66651 12.8333 7.99984 13.5621 7.99984 14.6667M7.99984 5.16667L7.99984 14.6667"
              stroke="#EC1C2D"
              stroke-width="1.5"
              stroke-linecap="round"
            />
          </g>
          <defs>
            <clipPath id="clip0_1121_3524">
              <rect width="16" height="16" fill="white" />
            </clipPath>
          </defs>
        </svg>
      </>
    ),
    '': (
      <>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
        >
          <g clip-path="url(#clip0_1121_3524)">
            <path
              d="M7.99984 5.16667C7.99984 4.0621 7.10441 3.16667 5.99984 3.16667L1.1665 3.16667L1.16651 12.8333L5.99984 12.8333C7.33317 12.8333 7.99984 13.5621 7.99984 14.6667M7.99984 5.16667C7.99984 4.0621 8.89527 3.16667 9.99984 3.16667L14.8332 3.16667L14.8332 12.8333L9.99984 12.8333C8.66651 12.8333 7.99984 13.5621 7.99984 14.6667M7.99984 5.16667L7.99984 14.6667"
              stroke="#EC1C2D"
              stroke-width="1.5"
              stroke-linecap="round"
            />
          </g>
          <defs>
            <clipPath id="clip0_1121_3524">
              <rect width="16" height="16" fill="white" />
            </clipPath>
          </defs>
        </svg>
      </>
    ),
  };
  return (
    <Box
      maxW={'306px'}
      href={externalUrl}
      isExternal
      textDecoration="none"
      mx={{ base: 'auto', md: '0' }}
      height={height || '422px'}
      bg={'rgba(255, 255, 255, 0.04)'}
      // boxShadow={
      //   '0px 1046px 249.8px 0px rgba(153, 192, 255, 0.00), 0px 669px 268px 0px rgba(153, 192, 255, 0.01), 0px 377px 226px 0px rgba(153, 192, 255, 0.04), 0px 167px 165.4px 0px rgba(153, 192, 255, 0.05), 0px 42px 89.8px 0px rgba(153, 192, 255, 0.05)'
      // }
      //en/wisdom/video/bangladeshi-hindus-waqf-times-now-interviews-sadhguru
      // boxShadow={
      //   '0px 1046px 349.8px 0px rgba(153, 192, 255, 0.00), 0px 769px 368px 0px rgba(153, 192, 255, 0.01), 0px 477px 326px 0px rgba(153, 192, 255, 0.04), 0px 267px 265.4px 0px rgba(153, 192, 255, 0.05), 0px 142px 189.8px 0px rgba(153, 192, 255, 0.05)'
      // }
    >
      <NextLink href={externalUrl} passHref target="_blank">
        <Link isExternal textDecoration="none">
          {/* box for image */}
          <Box height={'187px'}>
            <Image
              width={'100%'}
              height={'100%'}
              objectFit="inherit"
              src={card.heroImage?.url}
              alt={card.title}
              objectPosition="center"
            />
          </Box>

          {/* box for text */}
          <Box
            color={'#FFFFFF'}
            bgColor={'#1C2128'}
            px={'1rem'}
            gap={'1rem'}
            py={'1rem'}
            height={'100%'}
            display={'flex'}
            flexDir={'column'}
          >
            {/* category box */}
            <Flex
              justifyContent={'flex-end'}
              alignItems={'center'}
              gap={'.2rem'}
            >
              <Text {...InsightSt?.[lang]?.category}>{card.parentTitle}</Text>
              <Box>{icons[card.parentTitle]}</Box>
            </Flex>

            <Text
              fontSize={'20px'}
              lineHeight={'125%'}
              fontFamily="Geist"
              noOfLines={'2'}
              fontWeight={500}
            >
              {card?.title}
            </Text>
            <Text
              color="#FFFFFF99"
              textAlign={'left'}
              fontSize={'14px'}
              noOfLines={'4'}
              lineHeight={'19.6px'}
              fontFamily="Geist"
              fontWeight={400}
            >
              {card?.summary}
            </Text>
            <Text
              color="#FFFFFF99"
              fontSize={'12px'}
              lineHeight={'15.6px'}
              fontFamily="Geist"
              fontWeight={500}
            >
              {`${
                months[date.getMonth()]
              } ${date.getDate()},  ${date.getFullYear()}`}
            </Text>
          </Box>
        </Link>
      </NextLink>
    </Box>
  );
};

export default InsightCard;
